<template>
  <div class="td" v-if="getBean(index)">
    <div
      class="ivu-input-wrapper"
      v-if="valueKey == 'value' && ((edit && index == 1) || (edit && listKey == 'groupList' && index == 2) || (mode == 'base' && edit && index == 0))"
    >
      <input
        :value="getBean(index)[valueKey]"
        placeholder="请输入"
        class="ivu-input"
        type="number"
        @input="inputChange($event)"
        step="0.01"
        :disabled="isDisabled()"
      />
    </div>
    <span v-else>{{ getBean(index)[valueKey] * 1 ? getBean(index)[valueKey] : '-' }}</span>
  </div>
  <div class="td hide-td" v-else>-</div>
</template>
  
<script>
export default {
  components: {},
  props: {
    // 当前数据节点类型 obj 对象 arr 数组
    dataType: {
      default: 'obj'
    },
    dataKey: null, //当前对象的key 数据类型 first、second、third... 数组类型 1、2、3...
    valueKey: {
      default: 'value' //特殊 postfRateValue 首年后置 afterPostfRateValue 首年发放
    }, //当前对象的值的key
    listKey: null, //列表的key groupList organizationList
    list: null,
    mode: null,
    edit: null, //是否显示input
    index: null
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    // 获取数据实体
    getBean(index) {
      if (!this.list || typeof this.dataKey == 'undefined' || !this.list[index]['commissionInfoBeans']) {
        return null;
      }
      return this.list[index]['commissionInfoBeans'][this.dataKey];
    },
    // 机构费率输入
    inputChange(e) {
      if (e.data == '.') {
        return;
      }
      const list = this.list;
      const key = this.dataKey;
      const i = this.index;
      const valueKey = this.valueKey;
      let curValue = e.target.value;
      let curValueBak = e.target.value;
      let sum = this.getBean(0).value * 1;
      if (isNaN(curValue)) {
        curValue = 0;
      } else {
        curValue = curValue * 1;
      }
      curValue = Math.floor(curValue.mul(100)).div(100); //舍弃多余位数
      if (this.mode == 'base' && this.valueKey == 'value') {
        sum = 100;
      }
      if (this.listKey == 'groupList') {
        const otherValue = this.getBean(3 - i).value;
        sum = sum.sub(otherValue);
      }
      if (curValue > sum) {
        curValue = sum;
        e.target.value = sum;
      } else if (curValue < 0) {
        curValue = '0';
        e.target.value = '0';
      } else if (curValueBak === '') {
        e.target.value = '';
      } else {
        e.target.value = curValue;
      }
      if (this.listKey == 'groupList') {
        list[3] && this.$set(this.getBean(3), valueKey, sum.sub(curValue));
      } else {
        list[i + 1] && this.$set(this.getBean(i + 1), valueKey, sum.sub(curValue));
      }
      if (curValueBak === '') {
        list[i] && this.$set(this.getBean(i), valueKey, '');
      } else {
        list[i] && this.$set(this.getBean(i), valueKey, curValue);
      }
      if (key == 'first' && list[0] && list[1]) {
        const topPostfRateValue = Number(this.getBean(0).postfRateValue || 0); //上级 首年后置
        const topAfterPostfRateValue = Number(this.getBean(0).afterPostfRateValue || 0); //上级 首年发放
        let rate; //费率
        let postfRateValue; //当前 首年后置
        if (this.getBean(i).postfType == 1) {
          //30%后置
          rate = 0.3;
          postfRateValue = this.postfRateToNum(curValue.mul(rate)); //当前 首年后置
        } else if (this.getBean(i).postfType == 2) {
          //套利空间后置
          rate = Number(curValue).div(this.getBean(0).value * 1);
          postfRateValue = this.postfRateToNum(topPostfRateValue.mul(rate)); //当前 首年后置
        }
        if (postfRateValue > curValue) {
          //如果后置大于当前总值 置0
          postfRateValue = 0;
        }
        this.$set(this.getBean(i), 'postfRateValue', postfRateValue); //当前 首年后置
        if (this.listKey == 'groupList') {
          // 另一个数据 当前是团员另个就是团队长，当前是团队长另个就是团员
          const otherIndex = 3 - i;
          const otherPostfRateValue = Number(this.getBean(otherIndex).postfRateValue || 0); //另一个数据 首年后置
          const otherSfterPostfRateValue = Number(this.getBean(otherIndex).afterPostfRateValue || 0); //另一个数据 首年发放
          const curAfterPostfRateValue = curValue.sub(postfRateValue); //当前 首年发放
          this.$set(this.getBean(i), 'afterPostfRateValue', curAfterPostfRateValue); //当前 首年发放
          this.$set(this.getBean(3), 'postfRateValue', topPostfRateValue.sub(otherPostfRateValue.add(postfRateValue))); //剩余 首年后置
          this.$set(this.getBean(3), 'afterPostfRateValue', topAfterPostfRateValue.sub(curAfterPostfRateValue.add(otherSfterPostfRateValue))); //剩余 首年发放
        } else {
          const curAfterPostfRateValue = curValue.sub(postfRateValue); //当前 首年发放
          this.$set(this.getBean(i), 'afterPostfRateValue', curAfterPostfRateValue); //当前 首年发放
          this.$set(this.getBean(i + 1), 'postfRateValue', topPostfRateValue.sub(postfRateValue)); //剩余 首年后置
          this.$set(this.getBean(i + 1), 'afterPostfRateValue', topAfterPostfRateValue.sub(curAfterPostfRateValue)); //剩余 首年发放
        }
      }
    },
    /**
     * 后置费率位数处理 向上取整 以5进位 保留一位小数 忽略第3位小数
     * 0.45 => 0.5
     * 0.5 => 0.5
     * 0.56 => 1
     * 0.001 => 0
     */
    postfRateToNum(num) {
      if (isNaN(num)) {
        return num;
      }
      let integer = parseInt(num); //整数
      let remainder = parseInt(num.mul(100)) % 100; //取2位小数
      if (remainder == 0) {
        remainder = 0;
      } else if (remainder <= 50) {
        remainder = 50;
      } else {
        integer++;
        remainder = 0;
      }
      return Number(integer + '.' + remainder);
    },
    // 是否禁用输入
    isDisabled() {
      if (this.getBean(0).value * 1 == 0 && this.mode != 'base') {
        return true;
      }
      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>  